import {Box, Flex, Text} from '@chakra-ui/react'
import HeaderRevise from './HeaderRevise'
import ItemPhrase from './ItemPhrase'
import {useEffect, useRef, useState} from 'react'
import Loading from '@components/Loading'
import reviseRequest from '@apis/revise'

const RevisePage = () => {
  const [isLoading, setIsLoading] = useState<any>(true)
  const [phrases, setPhrases] = useState<any>([])
  const audioRef = useRef<any>()

  useEffect(() => {
    getPhrases()
  }, [])

  const getPhrases = async () => {
    setIsLoading(true)
    const res = await reviseRequest.getPhrasesToday()
    if (res) {
      if (res.status === 200) {
        setPhrases(res.data.data)
      }
    }
    setIsLoading(false)
  }

  const handlePlayAudio = (file: any) => {
    audioRef.current?.pause()
    audioRef.current = new Audio(file)
    audioRef.current.play()
  }

  return (
    <Box pt={{base: '16px', md: 0}}>
      <HeaderRevise />
      <Box mt={{base: '-170px', md: '-200px'}} mb={'32px'}>
        <Box
          position={'relative'}
          h={{base: 'unset', md: '500px'}}
          borderRadius={'20px'}
          bg={'white'}
          className="scroll-bar"
          overflow={'auto'}>
          {!isLoading ? (
            phrases.length > 0 ? (
              phrases.map((item: any, index: any) => {
                return (
                  <ItemPhrase
                    key={index}
                    data={item}
                    handlePlayAudio={handlePlayAudio}
                    type=""
                  />
                )
              })
            ) : (
              <Text>Chưa có cụm từ nào cần ôn</Text>
            )
          ) : (
            <Loading />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default RevisePage
